module.exports = {
    SERVER_DOMAIN: {
        VIDEO_PLAYER_DOMAIN: "https://web-public-viewer-video.wjthinkbig.com",
        // PDF_VIEWER_DOMAIN: "https://web-public-viewer-pdf.wjthinkbig.com",
        PDF_VIEWER_DOMAIN: "https://smartall-m.wjthinkbig.com",
        // QST_VIEWER_DOMAIN: "https://tqs.wjthinkbig.com",
        QST_VIEWER_DOMAIN: "https://smartall-m.wjthinkbig.com",
        GW_SMARTALL_MID_DOMAIN: "http://gw-smartall-mid.wjthinkbig-internal.com",
        SOCKET_DOMAIN: "https://socket-public-broadcast-activity.wjthinkbig.com",
        SAMID_WEB_DOMAIN: "https://smartall-mid-web.wjthinkbig.com",
        SAMID_WEB_DOMAIN_PATH: "https://smartall-m.wjthinkbig.com", // IOS 도메인
        // GW_ALLTAB_DOMAIN: "https://gw-thinkbigstudy.wjthinkbig.com",
    },

    CLASS_DETAIL_VDO_INFO: "http://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/PREVIEW/PREVIEW_CLAS_SEQ.MP4",
};
